
import { timeRangeOptions, RETURN_REASON_OPTIONS } from "@/utils/options";
import { PurchasePlanEnum } from "./enum";

const dateTypeOptions = [
    {id: 'createTime', text: '创建时间'},
    {id: 'reviewTime', text: '审核时间'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '状态',
    prop: 'statusList',
    components: [{
        name: 'gj-select',
        prop: 'statusList',
        propsData: {
            options: PurchasePlanEnum.statusOption,
            multiple: true,
            type:"multi-check",
            placeholder: '状态'
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: [],
    validator: [
        {required: true, message: '请选择状态', trigger: 'change'},
    ]
}, {
    label: '是否报价',
    prop: 'quote',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'quote',
        propsData: {
            placeholder: '是否报价',
            options:[{id: 1, text: '是'}, {id: 0, text: '否'}]
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
},{
    label: '是否加急',
    prop: 'urgent',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'urgent',
        propsData: {
            placeholder: '是否加急',
            options:[{id: 1, text: '是'},{id: 0, text: '否'}]
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    },{
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'},
    ]
}, {
    prop: 'dateType',
    defaultValue: 'createTime'
}]
